var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H15V22H9V20ZM16.906 13.712C17.936 12.506 19 11.259 19 9C19 5.141 15.859 2 12 2C8.141 2 5 5.141 5 9C5 11.285 6.067 12.528 7.101 13.73C7.459 14.148 7.83 14.581 8.185 15.079C8.329 15.285 8.565 16.075 8.776 17H8V19H9.162H14.837H16V17H15.226C15.439 16.073 15.676 15.281 15.819 15.075C16.171 14.572 16.545 14.135 16.906 13.712ZM14.182 13.925C13.748 14.542 13.386 16 13.176 17H10.825C10.616 15.998 10.253 14.537 9.814 13.92C9.407 13.348 8.988 12.859 8.618 12.428C7.644 11.294 7 10.544 7 9C7 6.243 9.243 4 12 4C14.757 4 17 6.243 17 9C17 10.521 16.357 11.274 15.385 12.413C15.012 12.851 14.589 13.346 14.182 13.925Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.120e8868.svg";
export { ForwardRef as ReactComponent };